import React, { useState } from "react";
import { Rule } from "antd/es/form";
import { ReactComponent as Power1 } from "src/static/icons/icon-power-1.svg";
import { ReactComponent as Power2 } from "src/static/icons/icon-power-2.svg";
import { ReactComponent as Power3 } from "src/static/icons/icon-power-3.svg";
import { ReactComponent as Power4 } from "src/static/icons/icon-power-4.svg";
import InfoModal from "@components/modals/InfoModal";
import BasicDivider from "@components/divider/BasicDivider";
import InfoButton from "@components/buttons/InfoButton";
import { ResourceInputItem } from "@type/estimateInput/estimateInput.response";
import { Checkbox } from "antd";
import HTMLReactParser from "html-react-parser";

interface ResourceOptionProps {
  resource: ResourceInputItem;
  mustBeChecked?: boolean;
  emptyErrorMessage?: string;
  onCheck: (key: string) => void;
  onUncheck: (key: string) => void;
  value?: boolean;
  className?: string;
  rules?: Rule[];
  disabled?: boolean;
}

const ResourceOption: React.FunctionComponent<ResourceOptionProps> = (
  props: ResourceOptionProps
) => {
  const { resource, onCheck, onUncheck, value = false, className } = props;

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const renderPotentialIcon = (value: number) => {
    switch (value) {
      case 1:
        return <Power1 aria-hidden="true" focusable="false" />;
      case 2:
        return <Power2 aria-hidden="true" focusable="false" />;
      case 3:
        return <Power3 aria-hidden="true" focusable="false" />;
      case 4:
        return <Power4 aria-hidden="true" focusable="false" />;
    }
    return <></>;
  };

  const getPotentialDescription = (value: number) => {
    switch (value) {
      case 1:
        return "Pouvoir méthanogène faible";
      case 2:
        return "Pouvoir méthanogène moyen";
      case 3:
        return "Pouvoir méthanogène élevé";
      case 4:
        return "Pouvoir méthanogène très élevé";
    }
    return "";
  };

  const onToggle = () => {
    if (value) onUncheck(resource.key);
    else onCheck(resource.key);
  };

  return (
    <div
      className={`resource-option d-flex justify-content-between ${className}`}
      key={resource.key}
    >
      <InfoModal
        visible={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
      >
        <div>
          <div className="d-flex align-items-center">
            {resource.potential && renderPotentialIcon(resource.potential)}
            <div className="span-title ms-3">
              {resource.potential &&
                getPotentialDescription(resource.potential)}
            </div>
          </div>
          <BasicDivider variant="grey" height={1} className={"w-100"} />
          <span className="span-title">{resource.label}</span>
          <p className="mt-3 mb-0">
            {resource.infoText && HTMLReactParser(resource.infoText)}{" "}
          </p>
        </div>
      </InfoModal>
      <div className="d-flex justify-content-center align-items-center">
        {resource.potential && renderPotentialIcon(resource.potential)}
        <label
          id={`resource-label-${resource.key}`}
          className={`ms-2 text-sm ${value ? "text-primary" : ""}`}
        >
          {resource.label}
        </label>
        {resource.infoText && (
          <InfoButton
            onClick={() => {
              setIsModalVisible(true);
            }}
            className={value ? "text-primary" : ""}
          />
        )}
      </div>
      <Checkbox
        checked={value}
        onChange={onToggle}
        aria-labelledby={`resource-label-${resource.key}`}
      />
    </div>
  );
};

export default ResourceOption;
